import api from '@/api'

var Q = require('q')

const state = {
  processes: []
}

const getters = {
  processes: (state) => state.processes
}

const mutations = {
  SET_PROCESSES (state, processes) {
    state.processes = processes
  },
  ADD_PROCESS (state, process) {
    state.processes.push(process)
  },
  DELETE_PROCESS (state, process) {
    let index = state.processes.findIndex(x => x.ID_PROCESO === process.ID_PROCESO)
    if (index !== -1) {
      state.processes.splice(index, 1)
    }
  }
}

const actions = {
  async getProcesses ({ commit }) {
    var deferred = Q.defer()

    try {
      const response = await api.process.getProcesses()
      commit('SET_PROCESSES', response.data)

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  },

  /* async createProcess ({ commit, dispatch }, data) {
    var deferred = Q.defer()

    try {
      const { file, fileItem, region, progressCallback } = data

      const formData = new FormData()
      formData.append('file', file)
      formData.append('FICHERO', JSON.stringify(fileItem))
      formData.append('REGION', JSON.stringify(region))

      await api.region.createRegion(formData, progressCallback)

      // commit('ADD_REGION', region)
      dispatch('getRegions') // Update files TODO: do it locally against the store??
      dispatch('file/getFiles', null, { root: true }) // Update files TODO: do it locally against the store??

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  }, */

  async deleteProcess ({ commit, dispatch }, process) {
    var deferred = Q.defer()

    try {
      /* const response = */ await api.process.deleteProcess(process)
      commit('DELETE_PROCESS', process)

      dispatch('file/getFiles', null, { root: true }) // Update files TODO: do it locally against the store??

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
